import {useEffect,useRef,useState} from 'react';
import {useLanguage} from '@/i18n/LanguageProvider';
import {supabase} from '@/integrations/supabase/client';
import {appleCalendarJournal} from '@/lib/appleCalendarWriteJournal';
import {confirmAppleMirrorReceipt,type AppleMirrorReceiptReference} from '@/lib/appleMirrorReceipt';
import {appleCalendarCopy} from '@/lib/appleCalendarCopy';
import {NativeAppleCalendarActionModal} from './NativeAppleCalendarActionModal';
export function AppleCalendarPendingActionLauncher({ownerId,onUpdated}:{ownerId:string|null;onUpdated():void}){
 const {lang,t}=useLanguage(),[pending,setPending]=useState(false),[open,setOpen]=useState(false),[blocked,setBlocked]=useState(false);
 const boundary=useRef({ownerId,alive:true});boundary.current.ownerId=ownerId;
 useEffect(()=>{let alive=true;boundary.current.alive=true;setOpen(false);setPending(false);setBlocked(false);
  if(ownerId)void appleCalendarJournal.load(ownerId).then(entry=>{if(alive)setPending(!!entry);}).catch(()=>{if(alive)setBlocked(true);});
  return()=>{alive=false;boundary.current.alive=false;};
 },[ownerId]);
 const acknowledge=async(receipt?:AppleMirrorReceiptReference)=>{
  if(!receipt)return true;const current=()=>boundary.current.alive&&boundary.current.ownerId===receipt.userId;
  return !!await confirmAppleMirrorReceipt({client:supabase,receipt,language:lang,isCurrent:current});
 };
 if(!ownerId||!pending&&!blocked)return null;
 return <><button className="min-h-11 rounded-xl border border-border px-4 text-sm" disabled={blocked} onClick={()=>setOpen(true)}>
  {blocked?t('mirror.connector.storageUnavailable'):appleCalendarCopy(lang).recover}</button>
  <NativeAppleCalendarActionModal open={open} prefill={{provider:'apple_calendar',action:'search',query:'',action_id:'standalone',expected_user_id:ownerId}}
   onClose={()=>{setOpen(false);void appleCalendarJournal.load(ownerId).then(entry=>{if(boundary.current.ownerId===ownerId)setPending(!!entry);}).catch(()=>setBlocked(true));}}
   onCreated={acknowledge} onConfirmed={onUpdated}/>
 </>;
}
